import { LoadState } from "../../../constants/enums";

export interface IBusinessCertificateofInsuranceState {
  certificateOfInsuranceList: IBusinessCertificateofInsurance[];
  totalRecords: number;
  loading: LoadState;
}

export interface IBusinessCertificateofInsurance {
  incremental_number: number;
  task_code: string;
  policy_number: string;
  customer_name: string;
  customer_code: string;
  policy_form_type: string;
  create_ts: string | null;
  created_by_id: number;
  status: string;
}

export const initialBusinessCertificateofInsuranceState: IBusinessCertificateofInsuranceState =
  {
    certificateOfInsuranceList: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
  };
